export default __webpack_public_path__ + "static/media/booking.f4a77935.svg";